import { render, staticRenderFns } from "./EmployeeDebitDetails.vue?vue&type=template&id=f8b89e38&scoped=true&"
import script from "./EmployeeDebitDetails.vue?vue&type=script&lang=js&"
export * from "./EmployeeDebitDetails.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeDebitDetails.vue?vue&type=style&index=0&id=f8b89e38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8b89e38",
  null
  
)

export default component.exports